import {v4 as generateUuid} from 'uuid'
import {ref, unref} from 'vue'

/**
 * Composable to expose UUID helper
 */
export function useUuid() {

  //Generate a UUID if we just need a random new one
  const uuid = ref(generateUuid())

  //Check if a value is a UUID
  const isUuid = value => {
    value = unref(value)
    return (
      typeof value === 'string' &&
      value.match(/^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i)
    )
  }

  //Expose interface
  return {
    uuid,
    isUuid,
    generateUuid,
  }
}
